import { render, staticRenderFns } from "./faceUpload.vue?vue&type=template&id=d9170c80&scoped=true&lang=html"
import script from "./faceUpload.vue?vue&type=script&lang=js"
export * from "./faceUpload.vue?vue&type=script&lang=js"
import style0 from "./faceUpload.vue?vue&type=style&index=0&id=d9170c80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9170c80",
  null
  
)

export default component.exports